import http from 'MeetingsBase/http/apiClient';
import { BUSINESS_UNITS_ENDPOINT } from 'MeetingsLib/constants/endpoints';
export function fetchBusinessUnits() {
  return http.get(BUSINESS_UNITS_ENDPOINT);
}